<template>
  <div v-if="!fetching">
    <post-list :section="section" :posts="posts" />

    <card-info
      v-for="(post, index) in posts"
      :key="index"
      title="Posts"
      :show-title="index === 0"
      class="post-information mt-4"
    >
      <template v-slot:above-title>
        <h3 v-if="index === 0" class="mb-4 font-weight-bold"></h3>
      </template>

      <template v-slot:below-title>
        <base-card-post-schedule
          :key="`post-${post.id}`"
          :ref="`post-${post.id}`"
          :post="post"
          :learning-unit="learningUnit"
          :learning-outcome="learningUnit.learning_outcome"
          :is-show-mark-complete="false"
          :is-private="false"
          :disabled="true"
          :show-date="true"
          :is-show-video-player="true"
          :is-show-attachment="true"
          :is-owner="false"
          :check-consent="false"
          :post-schedule="getPostSchedule(post.id, section.id)"
          :section-id="section.id"
          :section="section"
          class="card__post-information"
        >
        </base-card-post-schedule>
      </template>
    </card-info>
  </div>
</template>

<script>
import CardInfo from './CardInfo';
import LearningUnit from '@/models/LearningUnit';
import Post from '@/models/Post';
import PostSchedule from '@/models/PostSchedule';
import Section from '@/models/Section';
import { datetimeMixin } from '@/mixins/datetimeMixin';
import { postScheduleMixin } from '@/mixins/postScheduleMixin';
import BaseCardPostSchedule from '@/components/base-components/BaseCardPostSchedule';
import PostList from './PostList';

export default {
  components: {
    CardInfo,
    BaseCardPostSchedule,
    PostList
  },
  mixins: [datetimeMixin, postScheduleMixin],

  props: {
    learningUnit: {
      type: LearningUnit,
      required: true
    },

    section: {
      type: Section,
      required: true
    }
  },

  data() {
    return {
      fetching: false
    };
  },

  computed: {
    posts() {
      const { postScheduleIds = [] } = this;

      const posts = postScheduleIds.map((postScheduleId) => {
        const postSchedule = PostSchedule.query().whereId(postScheduleId).first();

        const post = Post.query()
          .whereId(postSchedule.post_id)
          .with('learning_outcome')
          .with('additional_criterion')
          .with('vimeo')
          .with('assessment_statuses')
          .with('meeting')
          .with('bunny_video')
          .first();

        return post;
      });

      return posts.filter(Boolean);
    }
  },

  async mounted() {
    await this.fetchPostSchedule();
  },

  methods: {
    async fetchPostSchedule() {
      let response;

      // (Refactor) filter meeting later on!!!

      this.fetching = true;

      try {
        ({ response } = await PostSchedule.api().findForTeacher(this.section.id));

        if (response && response.data) {
          this.recordPostSchedule(response.data);
        }
      } catch (error) {
        console.log(error);
        this.$toast.error('Cannot get posts, please try again');
      } finally {
        this.fetching = false;
      }
    }
  }
};
</script>

<style lang="scss">
.post-information {
  .card-info__title__box {
    margin-bottom: 2rem;
  }

  .card__post-information {
    .card__post {
      border-width: 0;
      box-shadow: none;

      .card-body {
        padding: 0;
      }
    }
  }
}
</style>
